import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIDFU {
    //This method returns compatible DFU images for a device
    getDFUImages(deviceID) {
        return fetchJSON(`/dfu/device/${deviceID}/images`);
    }
    // This method returns all DFU requests.
    // Provide a deviceID to get all DFU requests for only a single device.
    getDFURequests(deviceID) {
        const path = deviceID === undefined ? "/dfu" : `/dfu/device/${deviceID}`;
        return fetchJSON(path);
    }
    // This method creates a device firmware update request.
    // The device firmware name should match a name returned by the GET dfu/device/.device_id/images request.
    // Invalid firmware names will return a 400 bad request
    createDFURequest(deviceID, imageName) {
        return fetchJSON(`/dfu/device/${deviceID}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                name: imageName,
            }),
        });
    }
    //This method deletes a DFU request.
    deleteDFURequest(requestID) {
        return fetchWithAuth(`/dfu/${requestID}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-dfu.js.map